import React, {useState} from 'react';
import { FaUserAlt, FaLock } from "react-icons/fa";
import {useAuth} from "../contextos/AuthContext";
import {useNavigate} from "react-router-dom";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Alerta from '../elementos/Alerta';
import Logo from '../imagenes/logo.png';
import Fondo from '../imagenes/fondo.jpg';
import API from '../servicios/api';

const InicioSesion = () => {
    const navigate = useNavigate('');
    const [inputEmail, setInputEmail] = useState('');
    const [inputPassword, setInputPassword] = useState('');
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const {sesionOn, setEmail, setPassword} = useAuth();
    sessionStorage.setItem('sesion', 'false');
    sessionStorage.setItem('email', '');
    sessionStorage.setItem('password', '');

    const handleChange = (e) => {
        switch(e.target.name){
            case 'email':
                setInputEmail(e.target.value);
                break;
            case 'password':
                setInputPassword(e.target.value);
                break;
            default:
                break;
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setEstadoAlerta(false);
        setAlerta({});

        if(inputEmail === '' || inputPassword === ''){
            setEstadoAlerta(true);
            setAlerta({
                tipo: 'error',
                mensaje: 'Por favor rellena todos los datos'
            });
            return;
        }

        var datosEnviar = {email:inputEmail, clave:inputPassword}
        await fetch(API+"?consultarLogin=1",{
            method:"POST",
            body:JSON.stringify(datosEnviar)
        })
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            if(datosRespuesta.conectado){
                sessionStorage.setItem('email', inputEmail);
                sessionStorage.setItem('password', inputPassword);
                setEmail(inputEmail);
                setPassword(inputPassword);
                sesionOn();
                navigate("/");
            }
            else{
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'error',
                    mensaje: datosRespuesta.error
                });
            }
        })
        .catch(console.log)
    }

    return (
        <div className="login">
            <div className="row">
                <div className="col-sm-12 col-lg-6">
                    <img className="" width="100%" src={Fondo} alt="" />
                </div>

                <div className="col-sm-12 col-lg-6">
                    <div className="card pt-5 pb-5 ps-5 pe-5 border-0 ms-5 me-5">
                        <div className="card-header text-center bg-white border-bottom-0">
                            <img className="img-fluid" width="250" src={Logo} alt="" />
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text id="basic-addon1"><FaUserAlt /></InputGroup.Text>
                                    <Form.Control
                                        required
                                        type="email"
                                        placeholder="Correo"
                                        name="email"
                                        value={inputEmail}
                                        onChange={handleChange}
                                    />
                                </InputGroup>

                                <InputGroup className="mb-3">
                                    <InputGroup.Text id="basic-addon2"><FaLock /></InputGroup.Text>
                                    <Form.Control
                                        required
                                        type="password" 
                                        placeholder="Contraseña"
                                        name="password"
                                        value={inputPassword}
                                        onChange={handleChange}
                                    />
                                </InputGroup>

                                <button 
                                type="submit"
                                className="btn btn-success btn-xs btn-block w-100"
                                >Acceder</button>
                            </form>
                            
                        </div>
                    </div>
                </div>

                
            </div>
            <Alerta
                tipo = {alerta.tipo}
                mensaje = {alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setEstadoAlerta={setEstadoAlerta}
            />
        </div>
    );
}
 
export default InicioSesion;